import { render, staticRenderFns } from "./MfaPage.vue?vue&type=template&id=b3982e70&"
import script from "./MfaPage.vue?vue&type=script&lang=js&"
export * from "./MfaPage.vue?vue&type=script&lang=js&"
import style0 from "./MfaPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports